import { createSlice } from "@reduxjs/toolkit";
import {
  productEditTabs,
  productTabs,
} from "../../pages/Product/Product/Json/ProductJson";
import {
  ProductModalFieldsJSON,
  VariantModalFieldsJSON,
} from "../../pages/Product/Product/Json/ProductFieldsJson";
import { PPET_FROM_DATE, PPET_TO_DATE } from "../../Utils/FilterDateKeys";
import dateFormat from "dateformat";

const enterpriseid = localStorage.getItem("enterpriseid");

const initialState = {
  productData: [],
  productFieldJson: ProductModalFieldsJSON,
  selectedProduct: {
    tab: productTabs,
    tabEdit: productEditTabs,
    activeTabs: "Details",
    // activeEditTabs: "Details",
    detailsData: {},
    oemBenefits: {
      oemBenefitsData: [],
    },
    oem: {
      oemData: [],
      oemOptionName: "",
      oemListData: [],
      oemById: {},
    },
    variant: {
      variantData: [],
      variantFieldJson: VariantModalFieldsJSON,
      variantEdit: {
        id: null,
      },
    },

    // productAttribute:{},
    // productVariants:{},
  },
  benefits: [
    {
      id: 1,
      name: "",
      type: "",
    },
  ],
  benefitListData: [],
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [PPET_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [PPET_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProductData(state, action) {
      state.productData = action.payload;
    },
    setProductFieldJson(state, action) {
      state.productFieldJson = action.payload;
    },
    changeActiveTabs: (state, action) => {
      state.selectedProduct.activeTabs = action.payload;
    },
    setDetailsData(state, action) {
      state.selectedProduct.detailsData = action.payload;
    },
    setVariantData(state, action) {
      state.selectedProduct.variant.variantData = action.payload;
    },
    setVariantFieldJson(state, action) {
      state.selectedProduct.variant.variantFieldJson = action.payload;
    },
    setVariantEditID(state, action) {
      state.selectedProduct.variant.variantEdit.id = action.payload;
    },

    setBenefitsData(state, action) {
      state.selectedProduct.benefits.benefitsData = action.payload;
    },
    setOemData(state, action) {
      state.selectedProduct.oem.oemData = action.payload;
    },
    setOemListData(state, action) {
      state.selectedProduct.oem.oemListData = action.payload;
    },
    setOemById(state, action) {
      state.selectedProduct.oem.oemById = action.payload;
    },
    oemOptionNames: (state, action) => {
      state.selectedProduct.oem.oemOptionName = action.payload;
    },

    updateBenefitsName: (state, action) => {
      const { entityid, name } = action.payload;
      const matchingBenefit = state.benefitListData.find(
        (benefit) => benefit.entityid === entityid
      );
      if (matchingBenefit) {
        matchingBenefit.name = name;
      }
    },
    updateBenefitType: (state, action) => {
      const { entityid, value } = action.payload;
      const matchingBenefit = state?.benefitListData.find(
        (benefit) => benefit.entityid === entityid
      );
      if (matchingBenefit) {
        matchingBenefit.type = value;
      }
    },
    setBenefitListData(state, action) {
      state.benefitListData = action.payload;
    },
    // addType: (state, action) => {
    //   const { id, type } = action.payload;
    //   const benefitIndex = state.benefits.find((benefit) => benefit.id === id);
    //   if (benefitIndex) {
    //     benefitIndex.type.push(type);
    //   }
    // },
    setOemBenefitsData(state, action) {
      state.selectedProduct.oemBenefits.oemBenefitsData = action.payload;
    },
    setProductFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    setProductFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [AG_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [AG_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[PPET_FROM_DATE];
          delete state.filter.form[PPET_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setProductFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setProductSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
  },
});

export const {
  setProductData,
  changeActiveTabs,
  setDetailsData,
  setVariantData,
  setVariantFieldJson,
  setVariantEditID,
  addAttribute,
  deleteAttribute,
  updateAttributeName,
  addOption,
  deleteOption,
  setBenefitsData,
  setOemData,
  setOemById,
  setOemListData,
  addBenefits,
  deleteBenefits,
  updateBenefitsName,
  updateBenefitType,
  setBenefitListData,
  addEmptyBenefit,
  setOemBenefitsData,
  oemOptionNames,
  setProductFilterApi,
  setProductFilterForm,
  setProductFilterFormCopy,
  setProductSorting,
} = productSlice.actions;

export default productSlice.reducer;
